module.exports = __webpack_public_path__ + "img/Inflammation-BRCA_her2st.4dd12924.png";